"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../00_environment/Fonts");

var _Container = _interopRequireDefault(require("./Container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Divider = function Divider(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: {
      marginBottom: 10,
      marginTop: 20
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, {
    horizontal: true,
    style: (0, _Fonts.withDividerFont)({})
  }, text));
};

var _default = Divider;
exports["default"] = _default;